import type { CSSProperties } from 'react';

interface Props {
  height?: number | string;
  width?: number | string;
  borderRadius?: number | string;
  style?: CSSProperties;
}

export function Skeleton({ height = '1em', width = '100%', borderRadius = 6, style }: Props) {
  return (
    <span
      className="ts-skeleton"
      aria-hidden
      style={{
        display: 'inline-block',
        height,
        width,
        borderRadius,
        background:
          'linear-gradient(90deg, rgba(128,128,128,0.12) 0%, rgba(128,128,128,0.22) 50%, rgba(128,128,128,0.12) 100%)',
        backgroundSize: '200% 100%',
        animation: 'ts-skeleton-shimmer 1.4s infinite',
        ...style,
      }}
    />
  );
}
